import { Stack } from "@mui/material";

import { Link, Tooltip, Typography } from "@/components/ui-v2";
import { FlowIcon } from "@/components/ui-v2/icons";

type BlueprintInfoSectionProps = {
  blueprintId: string;
  name: string;
  path: string;
};

export const BlueprintInfo = (props: BlueprintInfoSectionProps) => {
  const { name, path } = props;

  return (
    <section>
      <Typography fontWeight={400} color="secondary.2">
        Workflow
      </Typography>
      <Link href={path}>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            alignItems: "center",
          }}
        >
          <FlowIcon sx={{ height: "18px", width: "18px" }} />
          <Tooltip title={name} arrow placement="left">
            <Typography
              sx={{
                textDecoration: "underline",
                textDecorationStyle: "dotted",
              }}
              variant="small"
              color="secondary.2"
              noWrap
            >
              {name}
            </Typography>
          </Tooltip>
        </Stack>
      </Link>
    </section>
  );
};
